<template>
  <div style="margin-bottom: 170px">
    <!-- Tab -->
    <BuTab></BuTab>
    <!-- Block -->
    <div class="block">
      <!-- top search bar -->
      <div class="pa-5 d-flex">
        <div class="form-input-group w-702px mr-5">
          <div class="prepend-icon"><v-icon>search</v-icon></div>
          <input
            type="text"
            class="pl-42px"
            placeholder="搜尋"
            v-model="filter.keyword"
          />
        </div>
        <TableControlShowState v-model="filter.status"></TableControlShowState>
        <button class="btn btn-primary w-88px" @click="getSubCategories">搜尋</button>
      </div>

      <!-- table -->
      <v-simple-table>
        <template v-slot:default>
          <thead>
          <div v-if="lengthOfisCheckedList > 0"
               class="form-item d-flex align-center px-5 h-60px batch">
            <h5 class="col-checkbox">
              <v-checkbox
                v-model="checkAllStatus"
                :indeterminate="indeterminate"
                @click="changeAllCheckbox"
              ></v-checkbox>
            </h5>
            <h5 class="mr-22px">{{ lengthOfisCheckedList }} 項已選取</h5>
            <div>
              <button class="btn btn-danger mr-10px" @click="multiDelete">
                <v-icon color="white" class="mr-2">delete</v-icon>
                <span>刪除</span>
              </button>
            </div>
            <div>
              <button class="btn mr-10px" @click="changePublish(true)">設為顯示</button>
            </div>
            <div>
              <button class="btn" @click="changePublish(false)">設為隱藏</button>
            </div>
          </div>
          <tr>
            <th>
              <v-checkbox
                v-model="checkAllStatus"
                :indeterminate="indeterminate"
                @click="changeAllCheckbox"
              ></v-checkbox>
            </th>
            <th class="text-left">SubCategory Name</th>
            <th class="text-left">Category</th>
            <th class="text-left">Order</th>
            <th class="text-left">ID</th>
            <th class="text-left">顯示/隱藏</th>
            <th class="text-left">編輯</th>
            <th class="text-left">刪除</th>
          </tr>
          </thead>
          <tbody>
          <tr
            v-for="item in subcategories"
            :key="item.id"
          >
            <td>
              <v-checkbox v-model="item.isChecked"></v-checkbox>
            </td>
            <td>
              <router-link
                :to="{
                  name: 'SubCategoryInfo',
                  params: {id: item.id}
                }">
                {{ item.name }}
              </router-link>
            </td>
            <td>{{ item.product_category.name }}</td>
            <td>{{ item.order }}</td>
            <td>{{ item.id }}</td>
            <td>
              <FormSwitch
                v-model="item.status"
                @changeStatus="changePublish(item.status, item.id)">
              </FormSwitch>
            </td>
            <td>
              <button class="btn square" @click="toSubCategoryEdit(item.id)">
                <v-icon>edit</v-icon>
              </button>
            </td>
            <td>
              <deleteDialog @confirm-delete="deleteItem(item.id)"></deleteDialog>
            </td>
          </tr>
          </tbody>
        </template>
      </v-simple-table>

      <!-- table footer -->
      <Pagination @handleNextPreEvent="getSubCategories" model="subcategory"></Pagination>
    </div>
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex';
import TableControlShowState from '@/components/TableControlShowState.vue';
import FormSwitch from '@/components/FormSwitch.vue';
import Pagination from '@/components/Pagination.vue';
import BuTab from '@/components/BuTab.vue';

import deleteDialog from '@/components/C-1b__CategoriesList_Dialog-ConfirmDelete.vue';

export default {
  components: {
    TableControlShowState,
    FormSwitch,
    deleteDialog,
    Pagination,
    BuTab,
  },
  data: () => ({
    checkAllStatus: false, // left top checkbox status
  }),
  computed: {
    ...mapState(['currentBuTabId']),
    ...mapState('subcategory', ['subcategories', 'filter']),
    lengthOfisCheckedList() {
      return this.subcategories.filter((item) => item.isChecked)
        .length;
    },
    indeterminate() {
      const isCheckedList = this.subcategories.filter(
        (item) => item.isChecked,
      );
      if (
        isCheckedList.length === 0 ||
        isCheckedList.length === this.subcategories.length
      ) {
        return false;
      }
      return true;
    },
    isCheckedListIds() {
      return this.subcategories.filter((item) => item.isChecked).map((item) => item.id);
    },
  },
  watch: {
    lengthOfisCheckedList(newValue) {
      if (newValue < this.filterNumPerPageTableList.length) {
        this.checkAllStatus = false;
      }
      if (newValue === this.filterNumPerPageTableList.length) {
        this.checkAllStatus = true;
      }
    },
    currentBuTabId(newValue) {
      this.filter.buId = newValue;
      this.getSubCategories();
    },
  },
  methods: {
    ...mapActions('subcategory', {
      getSubCategories: 'find',
      destroySubCategory: 'destroy',
      publish: 'publish',
      clear: 'clear',
    }),
    toSubCategoryEdit(id) {
      this.$router.push({
        name: 'SubCategoryInfoEdit',
        params: { id },
      });
    },
    changeAllCheckbox() {
      if (this.checkAllStatus) {
        this.subcategories.forEach(
          (item) => (item.isChecked = true),
        );
      } else {
        this.subcategories.forEach(
          (item) => (item.isChecked = false),
        );
      }
    },
    async deleteItem(id) {
      this.clear();
      await this.destroySubCategory(id).then(() => {
        this.getSubCategories();
      });
    },
    async changePublish(status, id) {
      this.checkAllStatus = false;
      await this.publish({
        ids: id ? [id] : this.isCheckedListIds,
        status,
      }).then(() => {
        this.getSubCategories();
      });
    },
    async multiDelete() {
      await this.isCheckedListIds.forEach((id) => {
        this.destroySubCategory(id).then(() => {
          this.getSubCategories();
        });
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.table {
  .col-pic {
    width: 40px;
    margin-right: 20px;
  }
  .col-sub-category-name {
    min-width: 174px;
    margin-right: 10px;
  }
  .col-category {
    min-width: 134px;
    margin-right: 10px;
  }
  .col-order {
    width: 80px;
    margin-right: 40px;
    text-align: right;
  }
  .col-id {
    width: 80px;
    text-align: right;
  }
  .col-show {
    margin-right: 40px;
  }
}
</style>
